export * from './delete.component';
